import { render } from "./Tables.vue?vue&type=template&id=c4c8d184"
import script from "./Tables.vue?vue&type=script&lang=ts"
export * from "./Tables.vue?vue&type=script&lang=ts"
script.render = render

export default script